import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faUserCircle,
  faSignOutAlt,
  faFileAlt,
  faCalendarAlt,
  faClock,
  faRupeeSign,
  faChartLine,
  faVectorSquare,
  faBuilding,
  faExpandAlt,
  faMapMarkerAlt,
  faRetweet,
  faTrashRestore,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import SearchField from "react-search-field";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../apiUrlConstant";
import statesData from "../geojson";
import Masters from "../masters/Masters";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import styles from "../masters/master.css";
import Select from "react-select";
//import { Map } from 'react-leaflet'
import TopHeader from "../layout/TopHeader";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import { Icon, latLng } from "leaflet";
import { Header } from "rsuite";
import Chart from "react-google-charts";
import { ChartPopup } from "../utils/utils";
class LeaseSummary extends React.Component {
  state = {
    redirect: false,
    rightSideData: [],
    mapData: [],
    barChartData: [["City", "Lease Count"]],
    lineChartData: [],
    center: [20.59, 78.96],
    counter: 0,
    zoomLevel: 4,
    stateName: "India",
    stateId: "",
    brands: [],
    brandCategoryName: "Select Brand",
    brandCategory: "",
    pinCode: "",
    enlargeChart: false,
    chartData: "",
    chartkey: "",
    pinCounter: 0
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
    this.onEachFeature = this.onEachFeature.bind(this);
  }
  loadBrands = async () => {
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/brand/get-brands?page=1&per_page=100&delay=1`
    );
    this.state.brands = response.data.data;
    this.setState({});
  };

  changeCategory = (newValue) => {
    this.state.brandCategory = newValue.value;
    this.state.brandCategoryName = newValue.label;

    this.filterPage();

    console.groupEnd();
  };
  changePin = (newValue) => {
    this.state.pinCode = newValue.target.value;
    const pincodes = this.state.pinCode.split(",");
    let access = true;
    for (let i in pincodes) {
      if (pincodes[i].trim().length != 6 && pincodes[i].trim().length > 0) {
        access = false;
      }
    }
    console.log(this.state.pinCode, "this.state.pinCode")
    console.log(access);
    if (access) {
      this.filterPage();
    }

    console.groupEnd();
  };

  filterPage = () => {
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/lease-report/get-state-wise-summary?state_id=${this.state.stateId}&brandId=${this.state.brandCategory}&pinCode=${this.state.pinCode}`, //
    }).then(function (response) {
      if (response.data.success) {
        var counter = ths.state.counter + 1;
        ths.setState({
          rightSideData: response.data.data,
          mapData: response.data.data.mapData,
        });

        console.log(response.data.data, "response.data.data");
        ths.renderCharts(ths);
      }
    });

    this.setState({});
  };

  componentDidMount() {
    this.loadBrands();
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/lease-report/get-state-wise-summary`, //?state_id=${this.state.id}
    }).then(function (response) {
      if (response.data.success) {
        self.setState({
          rightSideData: response.data.data,
          mapData: response.data.data.mapData,
        });
      }
    });

    this.renderCharts(self);
  }

  resetPage = () => {
    var counter = this.state.counter + 1;
    this.setState(
      {
        stateId: "",
        pinCode: "",
        brandCategory: "",
        brandCategoryName: "Select Brand",
        zoomLevel: 4,
        counter: counter,
        center: [20.59, 78.96],
        stateName: "India",
        pinCounter: Math.random()
      },
      () => {
        this.filterPage();
      }
    );

    var ths = this;
    // axios({
    //   method: "get",
    //   url: `${apiUrl.apiUrl.url}/lease-report/get-state-wise-summary?state_id=&brandId=${ths.state.brandCategory}`,
    // }).then(function (response) {
    //   if (response.data.success) {
    //     var counter = ths.state.counter + 1;
    //     ths.setState({
    //       rightSideData: response.data.data,
    //       zoomLevel: 4,
    //       counter: counter, // Math.round()
    //     });
    //   }
    // });
  };

  renderCharts = (self) => {
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/sales-input/get-state-wise-lease-count?state_id=${self.state.stateId}&brandId=${self.state.brandCategory}&pinCode=${this.state.pinCode}`,
    }).then(function (response) {
      console.log(response.data, "cahrt data");
      self.setState({
        barChartData: response.data.barChartData,
        lineChartData: response.data.lineChartData,
      });
    });
  };

  onEachFeature(feature, layer) {
    var ths = this;
    layer.on("click", function (e) {
      console.log(e.target.feature, "e.target.feature.properties");
      ths.setState({
        stateName: e.target.feature.properties.st_nm,
        stateId: e.target.feature.properties.state_code,
      });

      ths.renderCharts(ths);
      axios({
        method: "get",
        url: `${apiUrl.apiUrl.url}/lease-report/get-state-wise-summary?state_id=${e.target.feature.properties.state_code}&brandId=${ths.state.brandCategory}`,
      }).then(function (response) {
        if (response.data.success) {
          var counter = ths.state.counter + 1;
          ths.setState({
            rightSideData: response.data.data,
            mapData: response.data.data.mapData,
            center: [
              response.data.stateData.latitude,
              response.data.stateData.longitude,
            ],
            zoomLevel: response.data.stateData.zoom_level,
            counter: counter, // Math.round()
          });
        }
      });
    });
  }

  render() {
    return (
      <div>
        <TopHeader />

        <div className="masterContainer padding_left_class">

          <div className="absoluteItemForTopBar d-flex align-items-center gap-3">
            <Select
              placeholder="type to search"
              className="basic-single custom-select-style"
              classNamePrefix="custom-select-style-inner"
              isSearchable="true"
              name="brandCategory"
              value={{
                label: this.state.brandCategoryName,
                value: this.state.brandCategory,
              }}
              onChange={(e) => {
                this.changeCategory(e);
              }}
              options={this.state.brands.map((item) => ({
                label: item.brandName,
                value: item.brandId,
              }))}
            />
            <input
              placeholder="Enter Pincodes (Ex:  409201, 409203, ...)"
              onChange={(e) => {
                this.changePin(e);
              }}
              //value={this.state.pinCode}
              isSearchable="true"
              name="pinCode"
              classNames="basic-single"
              key={this.state.pinCounter}
            />
            <button className="resetBtn" onClick={(e) => { this.resetPage(e); }}>
              {/* <FontAwesomeIcon icon={faTrashRestore} /> */}
              <img src="/images/icons/reset.svg" alt="Reset Filters" />
            </button>
          </div>

          <div className="row m-0 mt-4 masterContainerContent">
            {/* <div className="col-12 p-0">
              <div className="selectDropdownForMapData">
                <div className="row m-0 summary align-items-center">
                  <div className="col-lg-5 ps-0 text-center">
                    <div className="row searchFields">
                      <div className="col-lg-6">
                        <div className="inputContainer">
                          <Select
                            placeholder="type to search"
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            isSearchable="true"
                            name="brandCategory"
                            value={{
                              label: this.state.brandCategoryName,
                              value: this.state.brandCategory,
                            }}
                            onChange={(e) => {
                              this.changeCategory(e);
                            }}
                            options={this.state.brands.map((item) => ({
                              label: item.brandName,
                              value: item.brandId,
                            }))}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer">
                          <input
                            placeholder="Enter Pincodes (Ex:  409201, 409203, ...)"
                            onChange={(e) => {
                              this.changePin(e);
                            }}
                            isSearchable="true"
                            name="pinCode"
                            classNames="basic-single"
                          value={{
                            label: this.state.brandCategoryName,
                            value: this.state.brandCategory,
                          }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 pe-0 text-end">
                    <Link to={`/dashboard`} className="btnLink">
                      {" "}
                      Portfolio Analytics{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-sm-4 ps-0 masterContainerContentL">
              <div className="mapHolder">
                <p className="portfolioText">
                  Portfolio: <span>{this.state.stateName}</span>
                </p>
                <div className="mapContainer">
                  <MapContainer
                    key={this.state.counter}
                    center={this.state.center}
                    zoom={this.state.zoomLevel}
                    scrollWheelZoom={false}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <GeoJSON
                      data={statesData.statesData}
                      bounds={this.state.bounds}
                      onEachFeature={this.onEachFeature}
                      style={this.style}
                    />
                    {this.state.mapData.map(function (item) {
                      return (
                        <Marker
                          position={[item.latiTude, item.longiTude]}
                          icon={
                            new Icon({
                              iconUrl: markerIconPng,
                              iconSize: [25, 41],
                              iconAnchor: [12, 41],
                            })
                          }
                        >
                          <Popup>{item.towerName}</Popup>
                        </Marker>
                      );
                    })}
                  </MapContainer>
                  {/* <p className="text-center">
                    <span
                      className="mapResetBtn"
                      onClick={(e) => {
                        this.resetPage(e);
                      }}
                    >
                      Reset
                    </span>
                  </p> */}
                </div>
              </div>
            </div>
            <div className="col-sm-8 pe-0 masterContainerContentR">
              <div className="datagridMain">
                <div className="dataGridInner">
                  <Link
                    to={`/lease-summary/view-lease/2/${this.state.brandCategory}/${this.state.stateId}`}
                    className="btnLink"
                  >
                    <h3><img src="/images/icons/total_lease.svg" alt="total_lease" /> Total Leases </h3>
                    <p>{this.state.rightSideData.total_lease}</p>

                  </Link>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/assets.svg" alt="assets" /> # of Assets </h3>
                  <p>{this.state.rightSideData.total_assets}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/gla.svg" alt="gla" /> Total GLA (Chargeable) (sq.ft)</h3>
                  <p>{this.state.rightSideData.gross_area}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/gla.svg" alt="gla" /> Total Carpet (sq.ft)</h3>
                  <p>{this.state.rightSideData.carpet_area}</p>
                </div>
                
                <div className="dataGridInner">
                  <h3><img src="/images/icons/wale.svg" alt="Wale" /> WALE (Months)</h3>
                  <p>{this.state.rightSideData.wale_months}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/wale.svg" alt="Wale" /> WALOE (Months)</h3>
                  <p>{this.state.rightSideData.waloe_months}</p>
                </div>
                <div className="dataGridInner">
                  <Link
                    to={`/reports/lease-expiry-report/${this.state.brandCategory}/${this.state.stateId}/3`}
                    className="btnLink"
                  >
                    <h3><img src="/images/icons/lease_expire.svg" alt="lease_expire" /> Lease Expiring In 3 Months</h3>
                    <p>{this.state.rightSideData.lease_expire_3_months}</p>
                  </Link>
                </div>
              </div>
              <div className="rightSideChart mt-3">
                <div className="enLargeBtnHolder d-flex justify-content-between align-items-center">
                  <h5>Total Leases State Wise</h5>
                  <button
                    className="enlargeBtn"
                    onClick={(e) => {
                      this.setState({
                        chartkey: Math.random(),
                        enlargeChart: true,
                        chartData: (
                          <Chart
                            width={"100%"}
                            height={300}
                            chartType="ColumnChart"
                            loader={<div>Loading Chart</div>}
                            data={this.state.barChartData}
                            options={{
                              title: "",
                              chartArea: { width: "80%" },
                              legend: {
                                position: "top",
                                alignment: "center",
                              },
                              hAxis: {
                                title: "Total Leases",
                                minValue: 0,
                              },
                              vAxis: {
                                title: "States",
                              },
                            }}
                            legendToggle
                          />
                        ),
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faExpandAlt} />
                  </button>
                </div>
                <Chart
                  width={"100%"}
                  height={300}
                  chartType="ColumnChart"
                  loader={<div>Loading Chart</div>}
                  data={this.state.barChartData}
                  options={{
                    title: "",
                    chartArea: { width: "80%" },
                    legend: { position: "top", alignment: "center" },
                    hAxis: {
                      title: " States",
                      minValue: 0,
                    },
                    vAxis: {
                      title: "Total Leases",
                    },
                  }}
                  legendToggle
                />
              </div>
            </div>
          </div>
          {/* <div className="parentContainer container-fluid"> */}
          {/* <div className="row summary align-items-center">
              <div className="col-lg-5 text-center">
                <div className="row searchFields">
                  <div className="col-lg-6">
                    <div className="inputContainer">
                      <Select
                        placeholder="type to search"
                        className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                        isSearchable="true"
                        name="brandCategory"
                        value={{
                          label: this.state.brandCategoryName,
                          value: this.state.brandCategory,
                        }}
                        onChange={(e) => {
                          this.changeCategory(e);
                        }}
                        options={this.state.brands.map((item) => ({
                          label: item.brandName,
                          value: item.brandId,
                        }))}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer">
                      <input
                        placeholder="Enter Pincodes (Ex:  409201, 409203, ...)"
                        onChange={(e) => {
                          this.changePin(e);
                        }}
                        isSearchable="true"
                        name="pinCode"
                        classNames="basic-single"
                      // value={{
                      //   label: this.state.brandCategoryName,
                      //   value: this.state.brandCategory,
                      // }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 text-end">
                <Link to={`/dashboard`} className="btnLink">
                  {" "}
                  Portfolio Analytics{" "}
                </Link>
              </div>
            </div> */}
          {/* <div className="row"> */}
          {/* <div className="col-lg-5">

              </div>
              <div className="col-lg-7 text-center">
                <div className="row">
                  <div className="col-lg-4 outerBox mb-3">
                    <Link
                      to={`/lease-summary/view-lease/2/${this.state.brandCategory}/${this.state.stateId}`}
                      className="btnLink"
                    >
                      <div className="row">
                        <div className="col-lg-9 textContent">
                          <h3>{this.state.rightSideData.total_lease}</h3>
                          <p>Total Leases</p>
                        </div>
                        <div className="col-lg-3 imgContent">
                          <FontAwesomeIcon icon={faFileAlt} />
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.total_assets}</h3>
                        <p># of Assets </p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faBuilding} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.gross_area}</h3>
                        <p>Total GLA (Chargeable) (sq.ft)</p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faVectorSquare} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.carpet_area}</h3>
                        <p>Total Carpet (sq.ft)</p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faVectorSquare} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.wale_months}</h3>
                        <p>WALE (Months)</p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.waloe_months}</h3>
                        <p>WALOE (Months)</p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <p>
                          <Link
                            to={`/reports/lease-expiry-report/${this.state.brandCategory}/${this.state.stateId}/3`}
                            className="btnLink"
                          >
                            <h3>
                              {this.state.rightSideData.lease_expire_3_months}
                            </h3>
                            Lease Expiring In 3 Months
                          </Link>
                        </p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faClock} />
                      </div>
                    </div>
                  </div>
                   <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.avg_monthly_sale}</h3>
                        <p>Avg Monthly Sales () </p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faRupeeSign} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.avg_monthly_mg}</h3>
                        <p>Avg Monthly MG </p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faFileAlt} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 outerBox mb-3">
                    <div className="row">
                      <div className="col-lg-9 textContent">
                        <h3>{this.state.rightSideData.avg_monthly_mg}</h3>
                        <p>Avg Net Sales </p>
                      </div>
                      <div className="col-lg-3 imgContent">
                        <FontAwesomeIcon icon={faChartLine} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div
                    className="col-lg-12 ps-0"
                    style={{ textAlign: "right" }}
                  >
                    <div className="enLargeBtnHolder">
                      <button
                        className="enlargeBtn"
                        onClick={(e) => {
                          this.setState({
                            chartkey: Math.random(),
                            enlargeChart: true,
                            chartData: (
                              <Chart
                                width={"100%"}
                                height={300}
                                chartType="ColumnChart"
                                loader={<div>Loading Chart</div>}
                                data={this.state.barChartData}
                                options={{
                                  title: "Total Leases State Wise",
                                  chartArea: { width: "80%" },
                                  legend: {
                                    position: "top",
                                    alignment: "center",
                                  },
                                  hAxis: {
                                    title: "Total Leases",
                                    minValue: 0,
                                  },
                                  vAxis: {
                                    title: "States",
                                  },
                                }}
                                legendToggle
                              />
                            ),
                          });
                        }}
                      >
                        <FontAwesomeIcon icon={faExpandAlt} />
                      </button>
                    </div>
                    <Chart
                      width={"100%"}
                      height={300}
                      chartType="ColumnChart"
                      loader={<div>Loading Chart</div>}
                      data={this.state.barChartData}
                      options={{
                        title: "Total Leases State Wise",
                        chartArea: { width: "80%" },
                        legend: { position: "top", alignment: "center" },
                        hAxis: {
                          title: " States",
                          minValue: 0,
                        },
                        vAxis: {
                          title: "Total Leases",
                        },
                      }}
                      legendToggle
                    />
                  </div>
                  <div className="col-lg-6">
                    <Chart
                      onClick={(e) => {
                        this.setState({ enlargeChart: true });
                      }}
                      width={"100%"}
                      height={300}
                      chartType="LineChart"
                      loader={<div>Loading Chart</div>}
                      data={this.state.lineChartData}
                      options={{
                        hAxis: {
                          title: "Months",
                        },
                        vAxis: {
                          title: "Rate / GLA",
                        },
                        backgroundColor: "#005b9b",
                        colors: ["#fff", "#fff"],
                      }}
                    />
                    <button
                      className="enlargeBtn"
                      onClick={(e) => {
                        this.setState({
                          chartkey: Math.random(),
                          enlargeChart: true,
                          chartData: (
                            <Chart
                              onClick={(e) => {
                                this.setState({ enlargeChart: true });
                              }}
                              width={"100%"}
                              height={300}
                              chartType="LineChart"
                              loader={<div>Loading Chart</div>}
                              data={this.state.lineChartData}
                              options={{
                                hAxis: {
                                  title: "Months",
                                },
                                vAxis: {
                                  title: "Rate / GLA",
                                },
                                backgroundColor: "#005b9b",
                                colors: ["#fff", "#fff"],
                              }}
                            />
                          ),
                        });
                      }}
                    >
                      Enlarge Chart
                    </button>
                  </div>
                </div>
              </div> */}
          {/* <div className="datagridMain">
                <div className="dataGridInner">
                  <Link
                    to={`/lease-summary/view-lease/2/${this.state.brandCategory}/${this.state.stateId}`}
                    className="btnLink"
                  >
                    <h3><img src="/images/icons/total_lease.svg" alt="total_lease" /> Total Leases </h3>
                    <p>{this.state.rightSideData.total_lease}</p>

                  </Link>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/assets.svg" alt="assets" /> # of Assets </h3>
                  <p>{this.state.rightSideData.total_assets}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/gla.svg" alt="gla" /> Total GLA (sq.ft)</h3>
                  <p>{this.state.rightSideData.gross_area}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/wale.svg" alt="Wale" /> WALE (Months)</h3>
                  <p>{this.state.rightSideData.wale_months}</p>
                </div>
                <div className="dataGridInner">
                  <h3><img src="/images/icons/wale.svg" alt="Wale" /> WALE (Months)</h3>
                  <p>{this.state.rightSideData.waloe_months}</p>
                </div>
                <div className="dataGridInner">
                  <Link
                    to={`/reports/lease-expiry-report/${this.state.brandCategory}/${this.state.stateId}/3`}
                    className="btnLink"
                  >
                    <h3><img src="/images/icons/lease_expire.svg" alt="lease_expire" /> Lease Expiring In 3 Months</h3>
                    <p>{this.state.rightSideData.lease_expire_3_months}</p>
                  </Link>
                </div>
              </div> */}
          {/* </div> */}
          {/* </div> */}
        </div>
        <ChartPopup
          key={this.state.chartkey}
          open={this.state.enlargeChart}
          content={this.state.chartData}
        />
      </div >
    );
  }
}

export default withRouter(LeaseSummary);
